import React from 'react';
import { Layout } from '../components/Layout';
import { SEO } from '../components/SEO';
export function PrivacyPolicyPage() {
  return <Layout data-id="element-1723" data-mp="31qt79m4p30rg">
      <SEO title="Politique de Confidentialité | ADCC" description="L'Association Dignité Compétence Création (ADCC) accorde une grande importance à la protection de vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre site web adcc.africa." url="https://adcc.africa/privacy-policy" data-id="element-1724" data-mp="31p8nmrjx528d" />
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-1725" data-mp="243kt6c70wtzh">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1726" data-mp="245473w57isy3">
          <h1 className="text-4xl font-bold mb-4" data-id="element-1727" data-mp="293p9o27xlopp">
            Politique de Confidentialité
          </h1>
          <p className="text-gray-300" data-id="element-1728" data-mp="1v46158b7kbcv">
            Dernière mise à jour : 10 Janvier 2026
          </p>
        </div>
      </div>

      <section className="py-20 bg-white" data-id="element-1729" data-mp="1z6kjlrayt93m">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1730" data-mp="29r3jwog0660r">
          <div className="prose prose-lg text-gray-600 max-w-none" data-id="element-1731" data-mp="29tg12zdxsccr">
            <p className="mb-8 leading-relaxed" data-id="element-1732" data-mp="24s0f953xq1tb">
              L'Association Dignité Compétence Création (ADCC) accorde une
              grande importance à la protection de vos données personnelles.
              Cette politique de confidentialité explique comment nous
              collectons, utilisons et protégeons vos informations lorsque vous
              utilisez notre site web adcc.africa.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-4" data-id="element-1733" data-mp="1lzxw9n3tm9fw">
              1. Données collectées
            </h2>
            <p data-id="element-1734" data-mp="1w0i0mymmzu2c">
              Nous collectons les informations que vous nous fournissez
              volontairement via nos formulaires :
            </p>
            <ul className="list-disc pl-6 mb-8 space-y-2" data-id="element-1735" data-mp="1892usvvniumc">
              {["Informations d'identité (nom, prénom)", 'Coordonnées (email, numéro de téléphone, ville/quartier)', "Informations professionnelles (CV, expérience, domaine d'expertise)", "Informations de paiement (lors d'un don, traitées de manière sécurisée par nos prestataires Stripe/PayPal)"].map((item, idx) => <li key={idx} data-id="element-1736" data-mp="26rcvbw68ss7q" data-mpi={idx}>{item}</li>)}
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-4" data-id="element-1737" data-mp="1a0u6sqk05fdr">
              2. Utilisation des données
            </h2>
            <p data-id="element-1738" data-mp="1e1nvhm59qy7p">Vos données sont utilisées exclusivement pour :</p>
            <ul className="list-disc pl-6 mb-8 space-y-2" data-id="element-1739" data-mp="1j1il7mdb5hr6">
              {['Traiter vos demandes (bénévolat, partenariat, recrutement, formation)', 'Gérer vos dons et émettre les reçus fiscaux', 'Vous envoyer notre newsletter (si vous y avez souscrit)', 'Améliorer nos services et notre communication'].map((item, idx) => <li key={idx} data-id="element-1740" data-mp="ns5kak4w19rh" data-mpi={idx}>{item}</li>)}
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-4" data-id="element-1741" data-mp="nui1gv2tng3h">
              3. Protection et partage des données
            </h2>
            <p data-id="element-1742" data-mp="e1u2pusa7224">
              Vos données personnelles sont strictement confidentielles. Elles
              ne sont jamais vendues ou louées à des tiers. Elles peuvent être
              partagées uniquement avec :
            </p>
            <ul className="list-disc pl-6 mb-8 space-y-2" data-id="element-1743" data-mp="53ig03ujcoey">
              {["Les membres habilités de l'équipe ADCC pour le traitement de votre dossier", 'Nos prestataires techniques (hébergement, paiement) soumis à des obligations de confidentialité', "Des employeurs partenaires (uniquement avec votre accord explicite dans le cadre d'un recrutement)"].map((item, idx) => <li key={idx} data-id="element-1744" data-mp="1kio7nmfe6gjv" data-mpi={idx}>{item}</li>)}
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-4" data-id="element-1745" data-mp="1kgl8ocw9hd30">
              4. Vos droits
            </h2>
            <p data-id="element-1746" data-mp="1xiglyle5ju8y">
              Conformément à la législation en vigueur, vous disposez d'un droit
              d'accès, de rectification, de suppression et d'opposition
              concernant vos données personnelles. Pour exercer ces droits,
              contactez-nous à :{' '}
              <a href="mailto:contact@adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1747" data-mp="1nmdkziv1e1nl">
                contact@adcc.africa
              </a>
            </p>
          </div>
        </div>
      </section>
    </Layout>;
}